import CounselorPage from './CounselorPage';

export default CounselorPage;
